import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';

const facilities = [
  { img:'/images/hb/facilities/reception-staff.jpg', icon:'fas fa-concierge-bell',    title:'Reception & Lobby', desc:'Grand marble-floored lobby with 24-hour reception, luggage handling and concierge service for every guest.' },
  { img:'/images/hb/facilities/bar-lounge.jpg',       icon:'fas fa-martini-glass',     title:'Bar & Lounge',      desc:'Fully stocked bar with premium spirits, wines, beers and cocktails. Comfortable seating and live sport on screen.' },
  { img:'/images/hb/facilities/swimming-pool.jpg',    icon:'fas fa-water-ladder',      title:'Rooftop Pool',      desc:'Rooftop pool with marina views and comfortable poolside seating, maintained to international standards.' },
  { img:'/images/hb/facilities/event-hall.jpg',       icon:'fas fa-champagne-glasses', title:'Event Hall',       desc:'Elegant ballroom with hardwood floors — seats up to 500 guests. Ideal for weddings and corporate events.' },
  { img:'/images/hb/facilities/boardroom.jpg',        icon:'fas fa-briefcase',         title:'Boardroom',        desc:'Glass-walled professional meeting space seating 20 executives. Equipped with AC, TV and full business facilities.' },
  { img:'/images/hb/facilities/lobby-lounge.jpg',     icon:'fas fa-couch',             title:'Guest Lounge',     desc:'Elegant gold-accented seating area for relaxing or meeting guests, just off the main lobby.' },
];

const included = ['Free WiFi throughout','24h Power Supply','24h Security & CCTV','Free Secure Parking','Air Conditioning','Hot Water in All Rooms'];

export default function Services() {
  return (
    <div className="page-wrapper">
      <Preloader />
      <Header />
      <PageTitle title="Facilities & Services" breadcrumbs={[{ label:'Facilities' }]} />

      <section style={{ padding:'64px 0' }}>
        <div className="auto-container">

          <div style={{ display:'flex', alignItems:'flex-end', justifyContent:'space-between', marginBottom:40, flexWrap:'wrap', gap:16 }}>
            <div>
              <span className="h2-label">What We Offer</span>
              <h2 style={{ fontFamily:'var(--gw-font-h,serif)', fontSize:'clamp(26px,3.2vw,44px)', color:'#111', lineHeight:1.15, margin:'8px 0 0' }}>
                World-Class Amenities
              </h2>
            </div>
            <Link to="/contact" className="h2-btn-primary">Make a Reservation</Link>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:20, marginBottom:48 }}>
            {facilities.map((f,i) => (
              <div key={i} style={{ background:'#f9f8f6', borderRadius:6, overflow:'hidden', border:'1px solid #e8e3dc', transition:'box-shadow 0.25s, transform 0.25s' }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow='0 10px 36px rgba(0,0,0,0.1)'; e.currentTarget.style.transform='translateY(-3px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow=''; e.currentTarget.style.transform=''; }}>
                <img src={f.img} alt={f.title} style={{ width:'100%', height:190, objectFit:'cover', display:'block' }} />
                <div style={{ padding:'20px 20px 22px' }}>
                  <div style={{ width:38, height:38, background:'rgba(176,141,87,0.12)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', marginBottom:10 }}>
                    <i className={f.icon} style={{ color:'#b08d57', fontSize:15 }}></i>
                  </div>
                  <h5 style={{ fontSize:17, fontFamily:'var(--gw-font-h,serif)', color:'#111', marginBottom:6 }}>{f.title}</h5>
                  <p style={{ fontSize:13, color:'#666', lineHeight:1.7, margin:0 }}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{ background:'#111827', borderRadius:6, padding:'28px 32px', display:'flex', alignItems:'center', gap:24, flexWrap:'wrap' }}>
            <div style={{ color:'rgba(255,255,255,0.5)', fontSize:11, fontWeight:700, letterSpacing:2, textTransform:'uppercase', flexShrink:0 }}>Always Included</div>
            {included.map((item,i) => (
              <div key={i} style={{ display:'flex', alignItems:'center', gap:7, color:'rgba(255,255,255,0.75)', fontSize:13 }}>
                <i className="fas fa-check" style={{ color:'#b08d57', fontSize:11 }}></i>{item}
              </div>
            ))}
          </div>

        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
